(function HotelEngineRateDetails($, Adzuki)
{
	'use strict';

	const component = {
		props: {
			rateDetails: {
				type    : Object,
				required: true,
			},
		},
		template: `
			<div class="pad5-vert-bottom">
				<div class="col-md-12" role="alert" v-if="rateDetails.code === 'SIG' || rateDetails.code === 'SGP'">
					<div class="alert alert-info">
						<p v-if="rateDetails.code === 'SIG'">SIG rates are always combinable with listed amenities.</p>
						<p v-else-if="rateDetails.code === 'SGP'">SGP rates may be combinable with amenities, please
							review specific rate descriptions for eligibility.</p>
					</div>
				</div>
				<div class="margin10-bottom">
					<div :class="['label', 'label-'+labelMarker(rateDetails.code)+'']">
						{{ displaySpecialtyRateCode(rateDetails.code) }}
					</div>
				</div>
				<div v-html="rateDetails.amenity"></div>
			</div>
		`,
		data() {
			return {
				baseUri: Adzuki.base_uri,
			};
		},
		computed: {
		},
		methods: {
			displaySpecialtyRateCode(code) {
				return Adzuki.HotelEngine.displaySpecialtyRateCode(code);
			},
			resolveSpecialtyRateCode(code) {
				return Adzuki.HotelEngine.resolveSpecialtyRateCode(code);
			},
			labelMarker(code) {
				let label;
				switch (this.resolveSpecialtyRateCode(code)) {
					case 'GCD':
					case 'THC':
						label = 'success';
						break;
					case 'FHR':
						label = 'info';
						break;
					case 'SIG':
						label = 'danger';
						break;
					case 'SGP':
						label = 'warning';
						break;
					default:
						label = 'primary';
						break;
				}
				return label;
			},
		},
		watch: {
		},
	};

	Adzuki.VueComponents.HotelEngineRateDetails = component;
}(jQuery, window.Adzuki || {}));
